import { allAssetTypes } from 'helpers/constants';

const normalizeAssetIdentifier = (value) => {
    if (value === null || value === undefined) { return value; }
    if (typeof value === 'number') { return value; }
    if (typeof value !== 'string') { return value; }

    const trimmedValue = value.trim();
    if (!trimmedValue) { return value; }

    // Keep identifiers with leading zeros as strings to avoid changing identity semantics.
    if (/^0\d+$/.test(trimmedValue)) { return trimmedValue; }

    if (/^\d+$/.test(trimmedValue)) {
        const numericValue = Number(trimmedValue);
        if (Number.isSafeInteger(numericValue)) {
            return numericValue;
        }
    }

    return trimmedValue;
};

export const getNormalizedAssetId = (asset) => {
    if (!asset) { return ''; }
    const rawId = asset?.assetId ?? asset?.id ?? asset?.componentId;
    return rawId === null || rawId === undefined ? '' : String(rawId);
};

export const normalizeCrossAssetV2Asset = (asset) => {
    if (!asset) { return null; }

    const resolvedId = normalizeAssetIdentifier(asset?.id ?? asset?.assetId ?? asset?.componentId);
    const resolvedAssetId = normalizeAssetIdentifier(asset?.assetId ?? resolvedId);
    return {
        ...asset,
        id: resolvedId,
        assetId: resolvedAssetId,
        name: asset?.name ?? asset?.assetName ?? asset?.componentName,
        componentName: asset?.componentName ?? asset?.assetName ?? asset?.name,
        componentTypeName: asset?.componentTypeName ?? asset?.assetType,
    };
};

export const isSameAsset = (firstAsset, secondAsset) => {
    const firstId = getNormalizedAssetId(firstAsset);
    const secondId = getNormalizedAssetId(secondAsset);
    return firstId && secondId ? firstId === secondId : false;
};

export const getAssetTypeValue = (asset) =>
    asset?.assetType || asset?.componentTypeName || asset?.assetTypeName || '';

export const filterAssetsBySearchAndType = (assets, searchText, assetTypeFilter) => {
    const normalizedSearch = searchText?.trim()?.toLowerCase() || '';
    return (assets || []).filter((asset) => {
        const name = (asset?.assetName || asset?.name || asset?.componentName || '').toLowerCase();
        const assetId = (asset?.assetId || asset?.id || '').toString().toLowerCase();
        const serialNumber = (asset?.assetSerialNumber || asset?.serialNumber || '').toString().toLowerCase();
        const type = getAssetTypeValue(asset);
        const typeMatch = assetTypeFilter === allAssetTypes || type === assetTypeFilter;
        const searchMatch = !normalizedSearch ||
            name.includes(normalizedSearch) ||
            assetId.includes(normalizedSearch) ||
            serialNumber.includes(normalizedSearch);
        return typeMatch && searchMatch;
    });
};

